import { FormattedMessage } from '@liveauctioneers/hammer-ui-core/intl';
import { BodyPrimary, H5 } from '@liveauctioneers/hammer-ui-core/text';
import { cn } from '@liveauctioneers/hammer-ui-theme/cn';
import { ReactNode } from 'react';

type Props = {
    body: ReactNode;
    className?: string;
    header: ReactNode;
};

export const DescriptionSection = ({ body, className, header }: Props) => {
    return (
        <div className={cn('flex flex-col gap-xs', className)}>
            <H5>{typeof header === 'string' ? <FormattedMessage id={header} /> : header}</H5>
            <BodyPrimary
                className="whitespace-pre-wrap"
                color="primary"
            >
                {body}
            </BodyPrimary>
        </div>
    );
};
